module.exports = __webpack_public_path__ + "img/08_continuous_(white).341d0c4f.svg";